import React, { useState } from 'react';
import './ContactForm.css';

// When running behind Nginx, API is on same origin at /api
const API_URL = process.env.REACT_APP_API_URL || '';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    province: '',
    monthlyBill: '',
    electricType: '',
    purpose: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const provinces = [
    'Hà Nội',
    'TP. Hồ Chí Minh',
    'Đà Nẵng',
    'Hải Phòng',
    'Cần Thơ',
    'Quảng Ngãi',
    'Bình Dương',
    'Đồng Nai',
    'Long An',
    'Bắc Ninh',
    'Hải Dương',
    'Nghệ An',
    'Thanh Hóa',
    'Quảng Nam',
    'Khánh Hòa',
    'Bình Định',
    'Gia Lai',
    'Đắk Lắk',
    'Lâm Đồng',
    'Bà Rịa - Vũng Tàu',
    'Tây Ninh',
    'Bình Phước',
    'Tiền Giang',
    'Bến Tre',
    'Vĩnh Long',
    'An Giang',
    'Kiên Giang',
    'Hậu Giang',
    'Sóc Trăng',
    'Bạc Liêu',
    'Cà Mau'
  ];

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(API_URL + '/api/register.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        setSubmitted(true);
        setSuccessMessage(data.message || 'Đăng ký thành công! Chúng tôi sẽ liên hệ bạn sớm nhất.');
        setFormData({
          fullName: '',
          phone: '',
          province: '',
          monthlyBill: '',
          electricType: '',
          purpose: ''
        });
        setTimeout(() => setSubmitted(false), 5000);
      } else {
        setError(data.message || 'Có lỗi xảy ra. Vui lòng thử lại.');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Không thể kết nối đến server. Vui lòng thử lại sau.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Contact Info */}
          <div className="col-lg-6" data-aos="fade-right">
            <div className="contact-info">
              <span className="section-tag">LIÊN HỆ</span>
              <h2 className="contact-title">
                NHẬN TƯ VẤN LẮP ĐẶT ĐIỆN NĂNG LƯỢNG MẶT TRỜI
              </h2>
              <p className="contact-description">
                Đăng ký ngay để nhận tư vấn miễn phí từ đội ngũ chuyên gia giàu kinh nghiệm của chúng tôi.
              </p>

              <div className="contact-features">
                <div className="contact-feature">
                  <div className="feature-icon">
                    <i className="fas fa-check-circle"></i>
                  </div>
                  <div className="feature-text">
                    <h4>Tư vấn miễn phí</h4>
                    <p>Đội ngũ chuyên gia tư vấn tận nơi</p>
                  </div>
                </div>

                <div className="contact-feature">
                  <div className="feature-icon">
                    <i className="fas fa-check-circle"></i>
                  </div>
                  <div className="feature-text">
                    <h4>Báo giá minh bạch</h4>
                    <p>Không phát sinh chi phí ẩn</p>
                  </div>
                </div>

                <div className="contact-feature">
                  <div className="feature-icon">
                    <i className="fas fa-check-circle"></i>
                  </div>
                  <div className="feature-text">
                    <h4>Hỗ trợ trả góp 80%</h4>
                    <p>Trả góp lên đến 60 tháng</p>
                  </div>
                </div>
              </div>

              <div className="contact-hotline">
                <div className="hotline-icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="hotline-info">
                  <span>Hotline tư vấn</span>
                  <a href="tel:0989786995">0989.786.995</a> - <a href="tel:0983913951">0983.913.951</a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-6" data-aos="fade-left">
            <div className="contact-form-wrapper">
              {submitted && (
                <div className="success-message">
                  <i className="fas fa-check-circle"></i>
                  <p>{successMessage}</p>
                </div>
              )}

              {error && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  <p>{error}</p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Họ và tên:</label>
                    <input
                      type="text"
                      name="fullName"
                      className="form-control"
                      placeholder="Nhập họ và tên"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div className="form-group">
                    <label>Số điện thoại:</label>
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="Nhập số điện thoại"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Tỉnh/Thành phố:</label>
                    <select
                      name="province"
                      className="form-select"
                      value={formData.province}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    >
                      <option value="">Chọn tỉnh/thành</option>
                      {provinces.map((p, i) => (
                        <option key={i} value={p}>{p}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Tiền điện/tháng:</label>
                    <input
                      type="text"
                      name="monthlyBill"
                      className="form-control"
                      placeholder="VD: 2.000.000 VNĐ"
                      value={formData.monthlyBill}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Loại điện:</label>
                    <select
                      name="electricType"
                      className="form-select"
                      value={formData.electricType}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    >
                      <option value="">Chọn loại điện</option>
                      <option value="1pha">Điện 1 pha</option>
                      <option value="3pha">Điện 3 pha</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Mục đích sử dụng:</label>
                    <select
                      name="purpose"
                      className="form-select"
                      value={formData.purpose}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    >
                      <option value="">Chọn mục đích</option>
                      <option value="family">Hộ gia đình</option>
                      <option value="production">Sản xuất</option>
                      <option value="business">Kinh doanh</option>
                    </select>
                  </div>
                </div>

                <button type="submit" className="btn btn-submit" disabled={loading}>
                  {loading ? (
                    <>
                      <i className="fas fa-spinner fa-spin me-2"></i>
                      Đang gửi...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane me-2"></i>
                      ĐĂNG KÝ TƯ VẤN MIỄN PHÍ
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;